import { render, staticRenderFns } from "./mainNavs.vue?vue&type=template&id=c6085ca2&scoped=true&"
import script from "./mainNavs.vue?vue&type=script&lang=js&"
export * from "./mainNavs.vue?vue&type=script&lang=js&"
import style0 from "./mainNavs.vue?vue&type=style&index=0&id=c6085ca2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6085ca2",
  null
  
)

export default component.exports